import { render } from "./optional-filters-button.vue?vue&type=template&id=53260654&ts=true"
import script from "./optional-filters-button.ts?vue&type=script&lang=ts&external"
export * from "./optional-filters-button.ts?vue&type=script&lang=ts&external"

import "./optional-filters-button.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__